var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2021_1674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.82697 16.9207L5.85233 20.5592L2.29004 20.6346C1.22544 18.66 0.621582 16.4008 0.621582 14C0.621582 11.6785 1.18618 9.4892 2.18696 7.56152H2.18772L5.35916 8.14296L6.74844 11.2954C6.45767 12.1431 6.29918 13.0531 6.29918 14C6.29929 15.0277 6.48545 16.0123 6.82697 16.9207Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3773 11.3838C28.5381 12.2307 28.6219 13.1053 28.6219 13.9992C28.6219 15.0015 28.5165 15.9792 28.3158 16.9223C27.6342 20.1315 25.8535 22.9338 23.3866 24.9169L23.3858 24.9161L19.3912 24.7123L18.8258 21.183C20.4628 20.223 21.742 18.7207 22.4159 16.9223H14.9297V11.3838H22.5251H28.3773Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3849 24.917L23.3857 24.9178C20.9865 26.8462 17.9388 28.0001 14.6211 28.0001C9.28955 28.0001 4.65418 25.0201 2.28955 20.6347L6.82648 16.9209C8.00877 20.0763 11.0526 22.3224 14.6211 22.3224C16.1549 22.3224 17.5919 21.9078 18.8249 21.184L23.3849 24.917Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5578 3.22306L19.0224 6.93613C17.7463 6.13845 16.2378 5.67766 14.6216 5.67766C10.9724 5.67766 7.87161 8.02687 6.74855 11.2954L2.18778 7.56153H2.18701C4.51703 3.06923 9.21086 0 14.6216 0C18.0186 0 21.1332 1.21002 23.5578 3.22306Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2021_1674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.621582)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon_google.447382307b2359d2bd67e3d93f48ffc1.svg";
export { ForwardRef as ReactComponent };